module.exports = __webpack_public_path__ + "img/calendar2.653b15ac.svg";